/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import GitService from '../../services/gitlab';

export default function BranchDifferences({ site }) {
  const newMergeRequestUrl = (from, to) => {
    return `${site.repo}/merge_requests/new?utf8=%E2%9C%93&merge_request%5Bsource_project_id%5D=${site.id}&merge_request%5Bsource_branch%5D=${from}&merge_request%5Btarget_project_id%5D=${site.id}&merge_request%5Btarget_branch%5D=${to}`;
  };

  const [branchDifference, setBranchDifference] = useState({
    developToPrelive: undefined,
    preliveToMaster: undefined,
    developToMaster: undefined,
  });

  const getBranchDifference = async (site) => {
    let diff = { developToPrelive: null, preliveToMaster: null, developToMaster: null };

    try {
      const developToPrelive = await GitService.compareBranches(site.id, 'develop', 'prelive');
      diff.developToPrelive = developToPrelive.data.diffs.length;
    } catch (err) {
      console.warn('develop → prelive failed:', err.message);
    }

    try {
      const preliveToMaster = await GitService.compareBranches(site.id, 'prelive', 'master');
      diff.preliveToMaster = preliveToMaster.data.diffs.length;
    } catch (err) {
      console.warn('prelive → develop failed:', err.message);
    }

    try {
      const developToMaster = await GitService.compareBranches(site.id, 'develop', 'master');
      diff.developToMaster = developToMaster.data.diffs.length;
    } catch (err) {
      console.warn('develop → master failed:', err.message);
    }

    setBranchDifference(diff);
  };

  useEffect(() => {
    getBranchDifference(site);
  }, []);

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Branch differences</h3>
      </div>
      <div className="card-body">
        {(branchDifference.developToPrelive == null && branchDifference.preliveToMaster == null && branchDifference.developToMaster == null) ? (
          (branchDifference.developToPrelive === null && branchDifference.preliveToMaster === null && branchDifference.developToMaster === null) ? (
            <div className="callout callout-warning text-center">
              No comparable branches exist.
            </div>
          ) : (
            <div className="callout callout-info text-center">
              Loading branch differences...
            </div>
          )
        ) : (
          <table className="table mh-300">
            <thead>
              <tr>
                {branchDifference.developToPrelive !== null && (
                  <th className="text-center">develop → prelive</th>
                )}
                {(branchDifference.developToPrelive === null && branchDifference.preliveToMaster === null) && (
                  <th className="text-center">prelive → master</th>
                )}
                {branchDifference.preliveToMaster !== null && (
                  <th className="text-center">develop → master</th>
                )}
              </tr>
            </thead>
            <tbody>
              <tr>
                {branchDifference.developToPrelive !== null && (
                  <td className="text-center">
                    <a
                      href={newMergeRequestUrl('develop', 'prelive')}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span
                        className={`badge ${
                          branchDifference.developToPrelive === 0
                            ? 'bg-black-25'
                            : 'badge-info'
                        }`}
                      >
                        {branchDifference.developToPrelive ?? 'N.A.'}
                      </span>
                    </a>
                  </td>
                )}
                {(branchDifference.developToPrelive === null && branchDifference.preliveToMaster === null) && (
                  <td className="text-center">
                    <a
                      href={newMergeRequestUrl('develop', 'master')}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span
                        className={`badge ${
                          branchDifference.developToMaster === 0
                            ? 'bg-black-25'
                            : 'badge-info'
                        }`}
                      >
                        {branchDifference.developToMaster ?? 'N.A.'}
                      </span>
                    </a>
                  </td>
                )}
                {branchDifference.preliveToMaster !== null && (
                  <td className="text-center">
                    <a
                      href={newMergeRequestUrl('prelive', 'master')}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span
                        className={`badge ${
                          branchDifference.preliveToMaster === 0
                            ? 'bg-black-25'
                            : 'badge-info'
                        }`}
                      >
                        {branchDifference.preliveToMaster ?? 'N.A.'}
                      </span>
                    </a>
                  </td>
                )}
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
